export const USER_ROLES = {
  REP: "REP",
  OWNER: "OWNER",
  MANAGER: "MANAGER",
  ADMIN: "ADMIN",
  TECH: "TECH",
  AP_ONLY: "AP_ONLY",
};

export const ROLE_TO_LABEL = {
  [USER_ROLES.ADMIN]: "Admin",
  [USER_ROLES.OWNER]: "Owner",
  [USER_ROLES.MANAGER]: "Manager",
  [USER_ROLES.REP]: "Representative",
  [USER_ROLES.TECH]: "Technician",
  [USER_ROLES.AP_ONLY]: "AP only",
};

export const ROLE_DISPLAY_ORDER = [
  USER_ROLES.ADMIN,
  USER_ROLES.OWNER,
  USER_ROLES.MANAGER,
  USER_ROLES.REP,
  USER_ROLES.AP_ONLY,
  USER_ROLES.TECH,
];

export const ROLE_OPTIONS = Object.values(USER_ROLES)
  .sort((a, b) => ROLE_DISPLAY_ORDER.indexOf(a) - ROLE_DISPLAY_ORDER.indexOf(b))
  .map((role) => ({
    value: role.toUpperCase(),
    label: ROLE_TO_LABEL[role.toUpperCase()],
  }));

export const ROLE_TO_ACCESS_DESCRIPTION = {
  [USER_ROLES.ADMIN]: "Full access to all Volca features",
  [USER_ROLES.OWNER]:
    "Take administrative actions on behalf of the business in Volca like withdrawing and depositing money, and paying advocates. Can do everything other users can do.",
  [USER_ROLES.MANAGER]:
    "Able to pay money to advocates, but not initiate transfers of funds to and from the business wallet.",
  [USER_ROLES.REP]:
    "See and update information for all referrals and advocates in Volca. Cannot send payouts to advocates or initiate transfers of funds to and from the business wallet.",
  [USER_ROLES.TECH]: "See referral code, personalized QR code, and leaderboard",
  [USER_ROLES.AP_ONLY]:
    "Use Accounts Payable and your own profile. Other products, business settings, and user management are hidden.",
};
